import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnTypeWithPayload } from 'hooks/usePopup'
import { ILedByGPOTable } from '../../../../redux/store/adminSplitFees/types'
import { LedByCommunityGroup } from '../../AdminSplitFees/Community/LedByCommunityTable/types'
import {
  editLedByCommunityPopupWithPayload,
  editLedByGPOPopupWithPayload
} from './constants'

type ContextProps = {
  editLedByGPOPopup: PopupReturnTypeWithPayload<{
    selectedRow: ILedByGPOTable
  }>
  editLedByCommunityPopup: PopupReturnTypeWithPayload<{
    selectedRows: LedByCommunityGroup[]
  }>
}

const basePopup = (title: string) => ({
  title
})

const SplitFeesPopupContext = createContext<ContextProps>({
  editLedByGPOPopup: editLedByGPOPopupWithPayload,
  editLedByCommunityPopup: editLedByCommunityPopupWithPayload
})

const SplitFeesPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const editLedByGPOPopupProps = usePopup<{
    selectedRow: ILedByGPOTable
  }>(basePopup('Edit Fees'))
  const editLedByCommunityPopupProps = usePopup<{
    selectedRows: LedByCommunityGroup[]
  }>(basePopup('Edit Fees'))

  const context = useMemo(
    () => ({
      editLedByGPOPopup: editLedByGPOPopupProps,
      editLedByCommunityPopup: editLedByCommunityPopupProps
    }),
    [editLedByCommunityPopupProps, editLedByGPOPopupProps]
  )

  return (
    <SplitFeesPopupContext.Provider value={context}>
      {children}
    </SplitFeesPopupContext.Provider>
  )
}

export const useSplitFeesPopup = () => useContext(SplitFeesPopupContext)

export default SplitFeesPopupProvider
